// Intent: owner wants A/B tests (first upsell milestone, tone) but the PostHog
// key isn't active yet. Local sticky assignment: first call flips a coin, the
// result persists in app-meta and every later call returns the same variant.
// When PostHog feature flags go live, this helper is the single seam to swap.

import { useAppMetaStore } from '@/store/app-meta-store';

export const EXP_GOAL_UPSELL_MILESTONE = 'goal_upsell_milestone';

/**
 * Sticky A/B variant for an experiment. Synchronous read of the persisted
 * assignment; assigns (and persists, fire-and-forget) on first use.
 */
export function variantFor(name: string): 'A' | 'B' {
  const s = useAppMetaStore.getState();
  const existing = s.experiments[name];
  if (existing) return existing;
  const variant: 'A' | 'B' = Math.random() < 0.5 ? 'A' : 'B';
  void s.setExperimentVariant(name, variant);
  return variant;
}
